import {PlayerDetails} from '@/api/User/useGetPlayerDetails';
import {useQuery} from '@tanstack/react-query';
import {getAthleteInfo, GetAthleteInfoParams} from '../api';

export type AthleteInfo = PlayerDetails;

export const useGetAthleteInfo = ({clientId, siteId}: GetAthleteInfoParams) => {
  return useQuery<AthleteInfo>({
    queryKey: ['athlete-info', clientId],
    queryFn: () => getAthleteInfo({clientId, siteId}),
    enabled: !!clientId && !!siteId,
  });
};
